import React, { ReactNode } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';
import { Image } from '../../components/Image';

import { VideoOpenButton } from './VideoOpenButton';
import { ImageProps } from '../Image/types';

export interface VideoThumbnailProps extends DefaultBsComponent {
  toggleVideo: any;
  ShortVideo: ReactNode;
  image?: ImageProps;
  gradient?: boolean;
  logo?: ImageProps;
  classnameThumbnail?: string;
  classnameBoxThumbnail?: string;
}

export const VideoThumbnail = ({
  toggleVideo,
  ShortVideo,
  image,
  gradient,
  logo,
  classnameThumbnail,
  classnameBoxThumbnail,
}: VideoThumbnailProps) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames(
        'VideoThumbnail',
        'relative overflow-hidden group',
        'flex items-center justify-center',
        'h-full cursor-pointer w-full',
        classnameBoxThumbnail,
      )}
      onClick={toggleVideo}
      onKeyDown={(e) => {
        if (e.key === 'enter') {
          toggleVideo();
        }
      }}
    >
      {image && !ShortVideo && (
        <Image
          {...image}
          className={classNames(
            'object-cover w-full h-full rounded-18',
            classnameThumbnail,
          )}
          sizes={
            image?.sizes || [
              '(max-width: 350px) 290px',
              '(max-width: 480px) 700px',
              '(max-width: 768px) 290px',
              '735px',
            ]
          }
        />
      )}
      {ShortVideo && (
        <div className="w-full h-full rounded-18 overflow-hidden">
          {ShortVideo}
        </div>
      )}
      {gradient && (
        <div
          className={classNames(
            'absolute w-full h-full rounded-18',
            'bg-thumbnail-overlay',
          )}
        />
      )}
      {logo && (
        <div
          className={classNames(
            'absolute flex justify-end',
            'h-24 overflow-hidden md:h-48 lg:h-64',
            'bottom-2 right-2 md:bottom-3 md:right-3',
            'lg:bottom-24 lg:right-24 rounded-6',
          )}
        >
          <Image
            {...logo}
            className="w-full h-full rounded-18"
            sizes={[
              '(max-width: 768px) 145px',
              '(max-width: 1024px) 290px',
              '382px',
            ]}
          />
        </div>
      )}
      <VideoOpenButton />
    </div>
  );
};
